<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Name</th>
        <th scope="col" class="border-0">Nome do Icone</th>
        <th scope="col" class="border-0 text-center">Icone</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in statuses" :key="index">
        <td class="td-1">
          <span>{{ row.id }}</span>
        </td>
        <td class="td-3 text-left link">
          <span @click.prevent="editStatus(row)">{{ row.name }}</span>
        </td>
        <td class="td-1">{{ row.icon }}</td>
        <td class="td-1 text-center">
          <i class="material-icons">{{ row.icon }}</i>
        </td>
        <td class="td-1">
          <d-button-group class="buttons">
            <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow(row.id)">
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
            </d-button>
          </d-button-group>
        </td>
      </tr>
      <tr v-if="statuses.length === 0">
        <td colspan="6" class="no-content">Ainda não tem nenhuma status cadastrada.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de status"
      message="Tem certeza que deseja excluir essa status?"/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProjectService from '_services/rest/modules/project';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import { _SELECTED_STATUS_, _SAVE_STATUS_SUCCESS_ } from '_modules/project/components/ProjectModel';

export default {
  name: 'account-table',
  props: {
    statuses: {
      type: Array,
    },
  },
  components: {
    ConfirmationModal,
  },
  data() {
    return {
      selectStatusId: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    editStatus(model) {
      Events.$emit(_SELECTED_STATUS_, model);
      this.setToggle({ type: 'status_modal', bool: true });
    },
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    confirmDeleteRow(id) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      this.selectStatusId = id;
    },
    deleteRow() {
      ProjectService.deleteStatus(this.selectStatusId)
        .then(() => {
          this.close();
          Events.$emit(_SAVE_STATUS_SUCCESS_);
          this.activeAlert({ message: 'Status deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
  .overlay {
    opacity: 0;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}

.material-icons {
  font-size: 1.7rem;
}

.td {
  &-1 {
    min-width: 100px;
    width: 10%;
  }
  &-3 {
    min-width: 300px;
    width: 30%;
  }
}
</style>
